module.exports = __webpack_public_path__ + "static/img/e-learning_youtube.b568e77d.svg";